import { Flex, Image, Text } from "@chakra-ui/react";
import React from "react";
import { FilledButton } from "../components/custom/Button";
import { Helmet } from "react-helmet-async";

const ErrorScreen = () => {
  return (
    <>
      {/* Helmet */}
      <Helmet>
        <title>404 Error - Page Not Found | 360fintax </title>
        <meta
          name="description"
          content="The page you're looking for may have been moved or is temporarily unavailable. Return to the 360FinTax homepage for more tax services and support."
        />
        <link rel="canonical" href="https://tax-services-nu.vercel.app/" />
      </Helmet>

      <Flex
        direction="column"
        px={{ base: "5", md: "10", lg: "20" }}
        alignItems="center"
        justifyContent="center"
        gap="5"
        py={{ base: "20", md: "20" }}
      >
        <Image
          src="../assets/404.png"
          alt="error"
          h={{ base: "200px", md: "350px" }}
          objectFit="contain"
        />
        <Text
          fontSize={{ base: "md", md: "xl" }}
          textAlign="center"
          w={{ base: "xs", md: "xl" }}
        >
          The page you are looking for might have been removed, had its name
          changed or is temporarily unavailable.
        </Text>
        <FilledButton title="BACK TO HOME" url="/" icon={null} mx="auto" />
      </Flex>
    </>
  );
};

export default ErrorScreen;
